import { Common, color } from '@stockbit/ui';
import styled from 'styled-components';

const { IconWrapper } = Common;
export const CloseIconWrapper = styled(IconWrapper).attrs({
  size: '30px',
})`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${color.sunsetOrange};
  height: 100% !important;
`;

export const TableWatchlistWrapper = styled.div`
  overflow-y: auto;
  padding-bottom: 30px;
  height: calc(100% - 40px);
  padding: 0px 12px 30px 12px;

  table {
    width: 100%;

    th {
      padding: 8px 4px;
      border-bottom: 1px solid rgb(245, 246, 247);
    }
    th:nth-child(1),
    td:nth-child(1) {
      width: 25%;
      min-width: 75.25px;
      max-width: 75.25px;
    }
    th:nth-child(2),
    td:nth-child(2) {
      width: 30%;
      min-width: 90.3px;
      max-width: 90.3px;
    }
    th:nth-child(3),
    td:nth-child(3) {
      width: 45%;
      min-width: 135.45px;
      max-width: 135.45px;
    }

    tr {
      position: relative;
      cursor: pointer;
    }
    tr.active {
      background: rgb(238, 238, 238);
    }
    tr:hover td {
      background: rgb(245, 246, 247);
    }
    tr td ${CloseIconWrapper} {
      display: none;
    }
    tr:hover td ${CloseIconWrapper} {
      display: flex;
    }

    td {
      line-height: 1.15;
      font-size: 12.5px;
      padding: 0;
      border-bottom: 1px solid rgb(245, 246, 247);

      a {
        > div {
          padding: 7px 4px;
        }
      }
    }
    td:not(:first-child) {
      text-align: right;
    }
    td.up {
      color: ${color.primary};
    }
    td.down {
      color: ${color.sunsetOrange};
    }
    td.neutral {
      color: ${color.suvaGrey};
    }
  }
`;
